import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetInvitePreviewV1Response } from './get-invite-preview-v1-response';
import { getInvitePreviewV1ResponseSchema } from './get-invite-preview-v1-response';

export async function getInvitePreviewV1Api(
  code: string,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetInvitePreviewV1Response>> {
  return getRequest<IGetInvitePreviewV1Response>({
    path: `/invite/${encodeURIComponent(code)}/v1`,
    schema: getInvitePreviewV1ResponseSchema,
    options,
  });
}
